import { Router as RouterCore } from "@general-backoffice/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import configuration from "./config/configuration";
import type { RootState, SessionState } from "./redux/reducers/session/state";
import routes from "./routes";

const { basename } = configuration;

const referrerTypesAsRoles = ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"];

interface AppRoute {
  authorize?: string[];
  accessRoles?: string[];
  validate?: (state: SessionState) => boolean;
  [key: string]: unknown;
}

const validateRoute = (route: AppRoute, state: SessionState) => {
  const { user, token } = state;
  let role = user?.role?.name;

  // Workaroud to allow certain referrerTypes as standalone roles
  if (role !== "Not verified" && referrerTypesAsRoles.includes(user?.referrerType ?? ""))
    role = user?.referrerType ?? undefined; // for referrerType

  let routeAuthorize = false;
  let roleAuthorize = false;
  let validateAuthorize;

  if (!route.authorize) routeAuthorize = true;
  else {
    if (route.authorize.includes("auth") && !!token) routeAuthorize = true;
    if (route.authorize.includes("unAuth") && !token) routeAuthorize = true;
    if (route.authorize.length <= 0) routeAuthorize = false;
  }

  if (!route.accessRoles) roleAuthorize = true;
  else {
    if (route.accessRoles.find((roleR: string) => roleR === role)) roleAuthorize = true;
    if (route.accessRoles.length <= 0) roleAuthorize = false;
  }

  if (!route.validate) validateAuthorize = true;
  else validateAuthorize = route.validate(state);

  return routeAuthorize && roleAuthorize && validateAuthorize;
};

const Router = () => {
  const { t } = useTranslation();
  const state = useSelector((state: RootState) => state.sessionState);
  return (
    <React.Fragment>
      <RouterCore
        basename={basename}
        scrollToTop
        routes={routes({ state, t })}
        validateRoute={(route) => validateRoute(route, state)}
      />
    </React.Fragment>
  );
};

export default Router;
